import React, { Component } from 'react'
import { Container, Row, Col , Button} from 'reactstrap';
import {
  isMobile, MobileOnlyView, isBrowser
} from "react-device-detect";
import { Link} from "react-router-dom";
import { FaEnvelope, FaFacebookSquare, FaGoogle, FaInstagram, FaPhone, FaUser, FaYoutube } from 'react-icons/fa';
import { FiFacebook, FiInstagram, FiYoutube } from 'react-icons/fi';

const styles = {
    backgroundImage: 'linear-gradient(15deg, #fff, #fefefefe)',
    paddingTop: '50px',
    color: '#000',
    textAlign: 'left',
    zIndex:9999,
  }
  
export default class Catlist extends Component {
  constructor(props){
    super(props);
    this.state={
      apiList: [],
      categoryImages:[]
    }
  }

  componentDidMount() {
    
      fetch(`/api/category`)
      .then((response)=>{
        return response.json()
      })
      .then((data)=>{
        this.setState({apiList:data})
      })
    }
render(){ 
  const {apiList} = this.state 
  return(
  
  <Row className="">     
     <Col md={6}> 
      <h4 className="mt-5 mt-md-3">MEN </h4>
      {apiList.map(x=>
      x.gender =="male" &&
      <div><Link to={``}><p className="mb-1 mt-3 font-weight-bold text-uppercase" style={{color:'#000'}}> {x.catname[0]}  </p></Link>   
      {x.subcats.map(y=>
      <Link  style={{color:'#000'}} to={`/productslist/${y}`}><small>{y}&nbsp;</small></Link>
      )}
      </div>
      )}  
     </Col>
     <Col md={6}> 
      <h4 className="mt-5 mt-md-3">WOMEN </h4>
      {apiList.map(x=>
      x.gender =="female" &&
      <div><Link to={``}><p className="mb-1 mt-3 font-weight-bold text-uppercase" style={{color:'#000'}}> {x.catname[0]}  </p></Link>   
      {x.subcats.map(y=>
      <Link  style={{color:'#000'}} to={`/productslist/${y}`}><small>{y}&nbsp;</small></Link>
      )}
      </div>
      )} 
     </Col>
    
   </Row>
  
)
  }
}



// WEBPACK FOOTER //
// ./src/components/Catlist.js